import * as types from "../../mutation-types";
import IngredientsProvider from "../../../providers/IngredientsProvider";
import config from "../../../appconfig/index";
// initial state
const state = {
	ingredients: [],
	skipCounter: 0,
	selectedIngredientId: undefined,
	readingFinished: false, // are all records read
	editState: false
};

// getters
const getters = {
	ingredients: state => state.ingredients,
	selectedIngredientId: state => state.selectedIngredientId,
	ingredientsReadingFinished: state => state.readingFinished,
	ingredientEditingState: state => state.editState
};

// actions
const actions = {
	// ingredients
	createIngredient: ({dispatch, getters}, ingredient) => {
		return IngredientsProvider.createIngredient(ingredient, getters.jwtToken).then((response) => {
			// update vuex store with new ingredient
			dispatch("refreshIngredients", {ingredientId: response.data.id});
			return {ingredientId: response.data.id};
		});
	},
	updateIngredient: ({dispatch, getters}, ingredient) => {
		return IngredientsProvider.updateIngredient(ingredient, getters.jwtToken).then(() => {
			// update vuex store with new ingredient
			return dispatch("refreshIngredients");
		});
	},
	deleteIngredient: ({dispatch, getters}, productIngredient) => {
		return IngredientsProvider.deleteIngredientAndProductIngredients(productIngredient, getters.jwtToken).then(() => {
			return dispatch("refreshIngredients",{ingredientId: -1});
		});
	},
	deleteIngredientOnly: ({dispatch, getters}, ingredient) => {
		return IngredientsProvider.deleteIngredient(ingredient, getters.jwtToken).then(() => {
			return dispatch("refreshIngredients");
		});
	},
	refreshIngredients({commit}, payload=null) {
		return refreshAllIngredients(commit, payload);
	},
	setSelectedIngredient({commit, getters}, {ingredientId}) {
		return setSelectedIngredientId(commit, getters, ingredientId);
	},
	setIngredientEditingState({ commit }, { newStateValue }) {
		commit(types.SET_INGREDIENT_EDIT_STATE, newStateValue);
	}
};

/*
	Begining of a zone with a helper functions
 */
function setSelectedIngredientId(commit, getters, ingredientId) {
	if(ingredientId !== null && ingredientId !== undefined){

		return IngredientsProvider.getIngredient(ingredientId, config.tenantId, getters.jwtToken)
			.then(() => {
				return commit(types.ADMIN_SET_SELECTED_INGREDIENT, {
					ingredientId
				});
			})
			.catch(() => {
				return commit(types.ADMIN_SET_SELECTED_INGREDIENT, {
					ingredientId: -1
				});
			});
	} else {
		return commit(types.ADMIN_SET_SELECTED_INGREDIENT, {
			ingredientId: -1
		});
	}

}
function refreshAllIngredients(commit) {
	commit(types.REFRESH_INGREDIENTS_END_OF_READING, [], 0); // refresh should ne started so revert the ingredients state
	commit(types.ADMIN_ALL_INGREDIENTS_READ, false); // nothing has been read if reading again
	return readAllIngredients(commit);

}

function readAllIngredients(commit){
	IngredientsProvider.getIngredients(state.skipCounter).then(ingredientsResponse => {
		commit(types.REFRESH_INGREDIENTS, ingredientsResponse);

		if(state.skipCounter < ingredientsResponse.ingredientsResponse.data.total) {
			return readAllIngredients(commit);
		} else {
			return commit(types.ADMIN_ALL_INGREDIENTS_READ, true);
		}
	});
}
/*
	End of a zone with a helper functions
 */

// mutations
const mutations = {
	[types.REFRESH_INGREDIENTS](state, ingredients) {
		const receivedArray = ingredients.ingredientsResponse.data.data.slice();

		if(receivedArray.length !== 0) {
			state.skipCounter += receivedArray.length;

			state.ingredients = state.ingredients.concat(receivedArray);
		}

	},
	[types.REFRESH_INGREDIENTS_END_OF_READING](state, ingredientsArrayValue = [], skipCounterValue = 0) {
		state.skipCounter = skipCounterValue;
		state.ingredients = ingredientsArrayValue;
	},
	[types.ADMIN_SET_SELECTED_INGREDIENT](state, { ingredientId }) {
		state.selectedIngredientId = ingredientId;
	},
	[types.ADMIN_ALL_INGREDIENTS_READ](state, value){
		state.readingFinished = value;
	},
	[types.SET_INGREDIENT_EDIT_STATE](state, value){
		state.editState = value;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
